module.exports = __webpack_public_path__ + "img/avatar0.d13d781d.png";